export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se annulli lo scambio, verrà chiuso senza completare l'operazione."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sei sicuro di voler annullare lo scambio?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sì, annulla"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, mantieni attivo"])}
}